import { InventoryDto } from "./InventoryDto";
import { ProductVariantDto } from "./ProductVariantDto";
import { ImageGroupDto } from "./ImageGroupDto";
import { ProductReviewDto } from "./ReviewDto";
import { RecommendationProductDto } from "./RecommendationProductDto";
var RecommendationTypes = {
    1: "Use It With",
    2: "You May Love",
    3: "Category Landing Page - Featured Items",
    4: "Recommended Ritual",
    5: "Pairs With",
};
var ProductDto = (function () {
    function ProductDto(ocapiProduct) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        this.questionsSummary = ocapiProduct.c_questionsSummary;
        this.questions = ocapiProduct.c_questions;
        this.reviewSummary = ocapiProduct.c_reviewSummary;
        this.reviews = (_a = ocapiProduct.c_reviews) === null || _a === void 0 ? void 0 : _a.map(function (r) {
            return ProductReviewDto.fromOcapi(r);
        });
        this.reviewAverage = ocapiProduct.c_reviewAverage;
        this.brand = ocapiProduct.brand;
        this.isVegan = ocapiProduct.c_isVegan;
        this.applicationTips = ocapiProduct.c_applicationTips;
        this.currency = ocapiProduct.currency;
        this.id = ocapiProduct.id;
        this.ingredients = ocapiProduct.c_ingredients;
        this.inventory = ocapiProduct.inventory ? InventoryDto.fromOcapi(ocapiProduct.inventory) : new InventoryDto();
        this.longDescription = ocapiProduct.long_description;
        this.shortDescription = ocapiProduct.short_description;
        this.minOrderQuantity = ocapiProduct.min_order_quantity;
        this.name = ocapiProduct.name;
        this.price = ocapiProduct.price;
        this.priceMax = ocapiProduct.price_max;
        this.stepQuantity = ocapiProduct.step_quantity;
        this.link = ocapiProduct.c_storefrontlink;
        this.isMaster = (_c = (_b = ocapiProduct.type) === null || _b === void 0 ? void 0 : _b.master) !== null && _c !== void 0 ? _c : false;
        this.imageGroups = ((_d = ocapiProduct.image_groups) === null || _d === void 0 ? void 0 : _d.length) ? ocapiProduct.image_groups.map(function (g) { return ImageGroupDto.fromOcapi(g); })
            : [];
        this.variations = (_f = (_e = ocapiProduct.variants) === null || _e === void 0 ? void 0 : _e.map(function (v) {
            return ProductVariantDto.fromOcapi(v, ocapiProduct);
        })) !== null && _f !== void 0 ? _f : [];
        this.variationAttributes = ocapiProduct.variation_attributes;
        this.color = ocapiProduct.c_color;
        this.isVariant = (_h = (_g = ocapiProduct.type) === null || _g === void 0 ? void 0 : _g.variant) !== null && _h !== void 0 ? _h : false;
        this.isVariationGroup = (_k = (_j = ocapiProduct.type) === null || _j === void 0 ? void 0 : _j.variation_group) !== null && _k !== void 0 ? _k : false;
        this.productSetProducts = ocapiProduct.c_productSetProducts;
        this.isProductSet = (_m = (_l = ocapiProduct.type) === null || _l === void 0 ? void 0 : _l.set) !== null && _m !== void 0 ? _m : false;
        if (!!ocapiProduct.c_overrideDisplayPrice) {
            this.overrideDisplayPrice = ocapiProduct.c_overrideDisplayPrice;
        }
        this.setTotalPrice = ((_o = this.productSetProducts) === null || _o === void 0 ? void 0 : _o.reduce(function (acc, current) {
            return acc + current.price;
        }, 0)) || 0;
        this.mmmEnabled = !!ocapiProduct.c_mmmEnabled;
        this.promoPrice = ocapiProduct.c_promoPrice || ocapiProduct.promoPrice;
        this.backInStockNotificationEnabled = (_p = ocapiProduct.c_bisnEnabled) !== null && _p !== void 0 ? _p : false,
            this.comingSoonEnabled = (_q = ocapiProduct.c_comingSoon) !== null && _q !== void 0 ? _q : false,
            this.backInStockNotificationUntil = (_r = ocapiProduct.c_bisnUntil) !== null && _r !== void 0 ? _r : "",
            this.backInStockNotificationStart = (_s = ocapiProduct.c_bisnStart) !== null && _s !== void 0 ? _s : "",
            this.addToBagStartDate = (_t = ocapiProduct.c_addToBagStartDate) !== null && _t !== void 0 ? _t : "",
            this.addToBagEndDate = (_u = ocapiProduct.c_addToBagEndDate) !== null && _u !== void 0 ? _u : "",
            this.upc = (_v = ocapiProduct.upc) !== null && _v !== void 0 ? _v : "";
        this.master = ocapiProduct.master;
        this.faqContentAsset = (_w = ocapiProduct.c_faqContentAsset) !== null && _w !== void 0 ? _w : "",
            this.featuredIngredientsCarousel = (_x = ocapiProduct.c_featuredIngredientsCarousel) !== null && _x !== void 0 ? _x : [],
            this.featuredReview = (_y = ocapiProduct.c_featuredReview) !== null && _y !== void 0 ? _y : {},
            this.productSetProducts = ocapiProduct.c_productSetProducts,
            this.primaryCategoryId = (_z = ocapiProduct.primary_category_id) !== null && _z !== void 0 ? _z : "",
            this.enableShadeFinder = (_0 = ocapiProduct.c_enableShadeFinder) !== null && _0 !== void 0 ? _0 : false,
            this.recommendationProducts = ocapiProduct.c_recommendations ? ocapiProduct.c_recommendations.map(function (recommendation) {
                var _a, _b, _c, _d, _e, _f;
                return new RecommendationProductDto((_b = (_a = recommendation.recommendation_type) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0, (_d = (_c = recommendation.recommendation_type) === null || _c === void 0 ? void 0 : _c.display_value) !== null && _d !== void 0 ? _d : "", (_e = recommendation.recommended_item_id) !== null && _e !== void 0 ? _e : "", (_f = recommendation.recommended_item_link) !== null && _f !== void 0 ? _f : "");
            }) : ocapiProduct.c_masterRecommendations ? (_1 = ocapiProduct.c_masterRecommendations) === null || _1 === void 0 ? void 0 : _1.map(function (recommendation) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return new RecommendationProductDto((_b = (_a = recommendation.recommendation_type) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0, ((_c = recommendation.recommendation_type) === null || _c === void 0 ? void 0 : _c.display_value) ? (_d = recommendation.recommendation_type) === null || _d === void 0 ? void 0 : _d.display_value : (_f = RecommendationTypes[(_e = recommendation.recommendation_type) === null || _e === void 0 ? void 0 : _e.value]) !== null && _f !== void 0 ? _f : "", (_g = recommendation.recommended_item_id) !== null && _g !== void 0 ? _g : "", (_h = recommendation.recommended_item_link) !== null && _h !== void 0 ? _h : "");
            }) : undefined;
        this.defaultSelectedSKUs = ocapiProduct.c_defaultSelectedSKUs;
    }
    ProductDto.fromOcapi = function (ocapiProduct) {
        return new ProductDto(ocapiProduct);
    };
    return ProductDto;
}());
export { ProductDto };
//# sourceMappingURL=ProductDto.js.map